var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex-lg-row flex-grow-1 bloc-group pl-1 pr-1 pl-md-3 pr-md-3 pl-lg-5 pr-lg-5 rounded",class:_vm.bgClass},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }